import { render, staticRenderFns } from "./SvlpComponentNavAccesibilidad.vue?vue&type=template&id=24ccd881&scoped=true"
import script from "./SvlpComponentNavAccesibilidad.vue?vue&type=script&lang=js"
export * from "./SvlpComponentNavAccesibilidad.vue?vue&type=script&lang=js"
import style0 from "./SvlpComponentNavAccesibilidad.vue?vue&type=style&index=0&id=24ccd881&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ccd881",
  null
  
)

export default component.exports